import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import Layout from '../../Layout';
import { CategoryLevels, LevelsType } from '../lib';
import { CategoryLevel } from './CategoryLevel';

import styles from './SetupIPACategoryLevelsCategoryLevels.module.scss';

const { Section, Title, Subtitle } = Layout;

interface SetupIPACategoryLevelsCategoryLevelsProps {
  segments: LevelsType[];
  form: UseFormReturn<CategoryLevels>;
}

export const SetupIPACategoryLevelsCategoryLevels = ({ form, segments }: SetupIPACategoryLevelsCategoryLevelsProps) => {
  return (
    <Section.Root>
      <Section.Header>
        <Title>Níveis de categoria</Title>
        <Subtitle>Edite os nomes dos níveis de categorias existentes para personalizar a organização no IPA.</Subtitle>
      </Section.Header>

      <div className={styles['category-levels']}>
        {segments.map((segment, index) => (
          <CategoryLevel key={segment.field} form={form} index={index} />
        ))}
      </div>
    </Section.Root>
  );
};
